<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Panel administratora</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-container>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs10>
					<v-btn @click="generateControlSums">Generuj sumy kontrolne</v-btn>
				</v-flex>
				<v-flex xs1/>
			</v-layout>
		</v-container>

	</v-card>
</template>

<script>

	import {SecretSettings} from "@/api/generated/SecretSettings";

	export default {
		name: "ParagraphsView",

		data () {
			return {
				dialog: false
			};
		},

		computed: {},

		methods: {
			generateControlSums () {
				this.$confirm("Czy na pewno chcesz wygenerować sumy kontrolne? Sumy kontrolne zostaną wygenerowane" +
					"dla wszystkich rekordów, które nie mają jeszcze nadanej sumy kontrolnej.", {
					icon: "warning",
					title: "Generowanie sum kontrolnych",
					color: "info",
					width: 500,
				})
					.then(response => {
						if (response) {
							SecretSettings.postGenerateControlSum(this, success => {
								this.$messagesBus.$emit("success", "Wygenerowane nowe sumy kontrolne");
							}, error => {
								this.$messagesBus.$emit("error", "Wystąpił nieoczekiwany błąd");
							});
						}
					});
			}
		},

		created () {
		}
	};
</script>

<style scoped>

</style>
